import { createRoutine } from 'redux-saga-routines'

export const SET = 'SUCCESS_LAYOUT/SET'
export const CONTENT = createRoutine('SUCCESS_LAYOUT/CONTENT')
export const INVITE_CONTENT = createRoutine('SUCCESS_LAYOUT/INVITE_CONTENT')
export const PROFILE_CONTENT = createRoutine('SUCCESS_LAYOUT/PROFILE_CONTENT')
